/* global grecaptcha */
import React, { useState, useEffect, useContext, useCallback } from 'react';
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";
import styles from '../styles/components/connexion.module.scss';
import { validateTest } from '../components/validate.js';
import { Link } from "react-router-dom";
import { getAuth, signInWithEmailAndPassword, signOut, onAuthStateChanged } from "firebase/auth";
// import { getFirestore, doc, getDoc, updateDoc } from "firebase/firestore";
import { getFirestore, doc, getDoc, updateDoc, query, collection, where, getDocs } from "firebase/firestore";
import { db } from "../config/firebasedeconfig.js";
import 'boxicons/css/boxicons.min.css';
import { useNavigate } from 'react-router-dom';
import { defaultUsername, defaultEmail, defaultAvatarUrl } from '../constants';
import { sendPasswordResetEmail } from "firebase/auth";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { UserContext } from '../UserContext';
import { Helmet } from "react-helmet-async";
import { useLanguage } from '../contexts/LanguageContext';
import { useLocation } from 'react-router-dom';

const Connexion = () => {
  const { t } = useLanguage();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [username, setUsername] = useState('');
  const [avatar, setAvatar] = useState('');
  const [banner, setBanner] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [resetEmail, setResetEmail] = useState('');
  const history = useNavigate();
  const location = useLocation();
  const [placeholder, setPlaceholder] = useState("Votre courriel ou nom d'utilisateur");

  const {
    setIsLoggedIn: fetchUserData, updateContext, redirectTo, setRedirectTo
  } = useContext(UserContext);

  const auth = getAuth();
  // const db = getFirestore();
  // const userId = auth.uid;

  const [rememberMeChecked, setRememberMeChecked] = useState(false);

  // Fonction pour gérer la connexion
  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMessage(null);

    let loginEmail = email;

    // Si l'entrée ne contient pas de '@', on considère que c'est un nom d'utilisateur
    if (!email.includes('@')) {
      try {
        const usersRef = collection(db, "users");
        const q = query(usersRef, where("username", "==", email));
        const querySnapshot = await getDocs(q);
        if (querySnapshot.empty) {
          setErrorMessage(t('login.errorUserNotFound'));
          return;
        }
        // On suppose qu'il y a un seul utilisateur avec ce nom d'utilisateur
        querySnapshot.forEach((doc) => {
          loginEmail = doc.data().email;
        });
      } catch (error) {
        console.error("Erreur lors de la recherche du nom d'utilisateur :", error);
        setErrorMessage(t('login.errorUsernameSearch'));
        return;
      }
    }

    try {
      const userCredential = await signInWithEmailAndPassword(auth, loginEmail, password);
      const user = userCredential.user;
      // Met à jour l'état et Firestore, puis redirige l'utilisateur
      const userRef = doc(db, "users", user.uid);
      await updateDoc(userRef, { isOnline: true });
      updateContext(user.displayName, user.email, user.photoURL, user.photoBanner, true);

      const params = new URLSearchParams(location.search);
      const redirect = params.get('redirect');
      const safeRedirect = redirect && redirect.startsWith('/') ? redirect : null;
      history(safeRedirect || `/profilMemberPage/${user.uid}`);
    } catch (error) {
      console.error("Erreur lors de la connexion :", error);
      setErrorMessage(error.message);
    }
  };

  // Gewstion du password
  const handleForgotPassword = async () => {
    try {
      await sendPasswordResetEmail(auth, resetEmail);
    } catch (error) {
      console.error(`Erreur : ${error.message}`);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(users => {
      if (users) {
        setIsLoggedIn(true);
        fetchUserData();
      } else {
        setIsLoggedIn(false);
        updateContext(null, null, null);
      }
    });
    return () => unsubscribe();
  }, []);

  // Fenêtre modale ^pour mot de passe oublié

  const openModal = () => {
    console.log("Opening modal...");
    setIsModalOpen(true);
  };

  const closeModal = () => {
    console.log("Closing modal...");

    if (isMobile) {
      setIsHovered(true);

      window.setTimeout(() => {
        setIsHovered(false);
        setIsModalOpen(false);
      }, 350);

      return;
    }

    setIsHovered(false);
    setIsModalOpen(false);
  };

  const [message, setMessage] = useState(null); // Ajoutez ceci dans votre composant


  const [isHovered, setIsHovered] = useState(false);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  // Function to handle sign out
  const handleLogout = async () => {
    const user = auth.currentUser;
    if (user) {
      try {
        const userRef = doc(db, "users", user.uid);
        // Met à jour `isOnline` à false dans Firestore
        await updateDoc(userRef, { isOnline: false });
        // Déconnecte l'utilisateur
        await signOut(auth);
        console.log("Déconnexion réussie !");
      } catch (error) {
        console.error("Erreur lors de la déconnexion :", error);
      }
    } else {
      console.warn("Aucun utilisateur connecté pour effectuer la déconnexion.");
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (isLoggedIn) {
      await handleLogout();
      return;
    }

    await handleLogin(event);
  };

  useEffect(() => {
    if (window.grecaptcha) {
      grecaptcha.enterprise.ready(() => {
        console.log("grecaptcha est prêt !");
      });
    } else {
      console.error("grecaptcha n'est pas disponible.");
    }
  }, []);

  const onRecaptchaClick = (e) => {
    e.preventDefault();

    if (window.grecaptcha) {
      grecaptcha.enterprise.ready(async () => {
        try {
          const token = await grecaptcha.enterprise.execute('6LcJr5QqAAAAAA6DEG55o5i0fHtiTBZ62xa8zE3N', { action: 'LOGIN' });
          console.log("Token reçu : ", token);
          // Envoie ce token à ton backend pour vérification
        } catch (err) {
          console.error("Erreur avec reCAPTCHA :", err);
        }
      });
    } else {
      console.error("grecaptcha n'est pas défini.");
    }
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  return (
    <div className={styles.connexion}
      style={{
        backgroundImage: 'url("https://zupimages.net/up/23/32/g815.jpg")',
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
        overflowX: "hidden",
        overflowY: "auto", // Changé ici
        zIndex: "1",
        height: "100%", // Changé ici
        width: "100%",
        backgroundPositionX: "center",
        backgroundPositionY: "center",
        display: "grid", // Ajouté ici
        gridTemplateRows: "auto 1fr auto", // Ajouté ici
      }}
    >
      <Helmet>
        <title>{t('login.pageTitle')}</title>
        <meta name="description" content={t('login.metaDescription')} />
        <link rel="canonical" href="https://moviefrenzy.ca/connexion" />
      </Helmet>
      <Navigation />
      <div className={styles.connexionContainer}>
        <div className={styles.wrapper}>
          <form onSubmit={handleSubmit} className='formConnexion'
            style={{
              opacity: isModalOpen ? 0.15 : 1,
              backgroundColor: 'rgba(32, 2, 17, 0.7)'
            }}
          >
            <h1>{t('login.title')}</h1>
            <div className={styles.inputBox1}>
              <input
                type="text"
                placeholder={isMobile ? t('login.emailOrUsernamePlaceholderMobile') : t('login.emailOrUsernamePlaceholder')}
                name="email"
                required
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="username"
              />
              <i className='bx bxs-user' style={{ marginTop: '1rem' }}></i>
            </div>
            <div className={styles.inputBox2}>
              <input
                type={showPassword ? "text" : "password"}
                placeholder={t('login.passwordPlaceholder')}
                name="password"
                required
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"  // ajouté
              />
              <i className='bx bxs-lock-alt' style={{ marginTop: '1rem' }}></i>
              <div className={styles.passwordMaskContainer}>
                <button type="button" onClick={togglePasswordVisibility} className={styles.passwordMask}>
                  {showPassword ? <i className='bx bx-hide'></i> : <i className='bx bx-show'></i>}
                </button>
              </div>
            </div>
            <div className={styles.remeber}>
              <label className={styles.remeber_Int}>
                <input
                  type="checkbox"
                  className={styles.customCheckbox}
                  checked={rememberMeChecked} // Ajouté pour refléter l'état
                  onChange={(e) => setRememberMeChecked(e.target.checked)} // Mettre à jour l'état
                />
                <span className={styles.customCheckbox_span}>{t('login.rememberMe')}</span>
              </label>
              <div className={styles.forgetpasswordMother}>
                <button type="button" onClick={openModal} className={styles.forgetpassword}>{t('login.forgotPassword')}</button>
              </div>
            </div>
            {/* <button
              type="submit"
              className={styles.btn}
              onClick={isLoggedIn ? handleLogout : handleLogin}
            >
              {isLoggedIn ? t('login.logoutButton') : t('login.loginButton')}
            </button> */}
            <button
              type="submit"
              className={styles.btn}
            >
              {isLoggedIn ? t('login.logoutButton') : t('login.loginButton')}
            </button>

            {errorMessage && (
              <div
                style={{
                  color: '#00FFFF',
                  marginTop: '1rem',
                  fontWeight: 'bold',
                  textAlign: 'center',
                  wordBreak: 'break-word'
                }}
              >
                {errorMessage}
              </div>
            )}

            {message && <div>{message}</div>}
            <div className={styles.register}>
              <p>{t('login.noAccount')} </p>
              <Link to="/creercompte">{t('login.registerLink')}</Link>
            </div>
          </form>
          {/* Modale */}
          {console.log(isModalOpen)}
          {isModalOpen && (
            <div className="modal"
              style={{
                display: isModalOpen ? 'flex' : 'none',
                position: 'fixed',
                width: isMobile ? '88vw' : '50vw',
                height: isMobile ? '52vh' : '50vh',
                top: isMobile ? '24vh' : '30vh',
                left: isMobile ? '50%' : '25vw',
                transform: isMobile ? 'translateX(-50%)' : 'none',
                backgroundBlendMode: "overlay",
                backgroundColor: isModalOpen ? 'rgba(0,0,0,0.7)' : 'rgba(255,51,204,1.0)',
                color: '#FF33CC',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9991,
                border: '3px solid #00FFFF',
                fontSize: '1rem',
                fontWeight: 'normal',
                flexDirection: 'column',
                textAlign: 'center',
                padding: '1rem',
                gap: '1rem',
                borderRadius: '10px',
                overflowY: 'hidden',  /* Masque les barres de défilement verticales */
                overflowX: 'hidden', /* Masque les barres de défilement horizontales */

              }}
            >
              <div className="containerVid"
                style=
                {{
                  position: 'absolute',
                  width: '100%',
                  height: '100%',
                  top: 0,
                  left: 0,
                  zIndex: "-7",
                  display: "block",
                  // visibility: windowWidth < 768 ? "hidden" : "visible",
                  overflowX: "hidden",
                  overflowY: "auto",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  backgroundAttachment: "fixed",
                  backgroundBlendMode: "overlay",
                  backgroundColor: isModalOpen ? 'rgba(0,0,0,0.7)' : 'rgba(255,51,204,1.0)',
                  opacity: "0.74",
                }}
              >
                <video autoPlay muted loop id="myVideo" style={{
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  backgroundAttachment: "fixed",
                  backgroundBlendMode: "overlay",
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  opacity: "0.2",
                  overflowX: "hidden",
                  overflowY: "auto",
                  display: "block",
                  // visibility: windowWidth < 768 ? "hidden" : "visible",
                  zIndex: "-8",
                }}
                  className="video-background"
                >

                  <source src={`${process.env.PUBLIC_URL}/images/Severalturquoiseflashes02.mp4`} type="video/mp4" />
                </video>
              </div>
              <h2
                style={{
                  position: 'relative',
                  transform: isMobile ? 'translateY(-8vh)' : 'none',
                  zIndex: 9999,
                }}
              >
                {t('login.resetPasswordTitle')}
              </h2>
              <input
                type="email"
                placeholder={t('login.resetPasswordInputPlaceholder')}
                value={resetEmail}
                onChange={(e) => setResetEmail(e.target.value)}
                style={{
                  width: isMobile ? '85%' : '35%',
                  height: '4vh',
                  borderRadius: '10px',
                  backgroundColor: 'rgba(0,0,0,0.7)',
                  color: isMobile ? '#00FFFF' : 'inherit',
                  outline: 'none',
                  border: '1px solid #00FFFF',
                  fontSize: isMobile ? '0.65rem' : '1rem',
                  padding: '0.5rem'
                }}
                id='inputEmailEntrez'
              />
              {/* Temporairement désactivé - reCAPTCHA
              <button onClick={onRecaptchaClick} className={styles.btn}>
                Vérifier avec reCAPTCHA
              </button>
              */}
              <button onClick={() => handleForgotPassword(resetEmail)}
                onMouseEnter={() => {
                  if (!isMobile) setIsHovered(true);
                }}
                onMouseLeave={() => {
                  if (!isMobile) setIsHovered(false);
                }}
                style={{
                  position: 'relative',
                  color: isHovered ? '#FFFFFF' : '#00FFFF',
                  backgroundImage: 'linear-gradient(to right, #D90093, #00FFFF)',
                  backgroundSize: isHovered ? '100% 100%' : '0% 100%',
                  border: '1.5px solid #D90093',
                  borderRadius: "10px",
                  width: isMobile ? '35vw' : '9vw',
                  height: '4.5vh',
                  fontSize: '1.25rem',
                  backgroundColor: 'transparent',
                  backgroundRepeat: 'no-repeat',
                  outline: 'none',
                  cursor: 'pointer',
                  zIndex: 9999,
                  overflow: 'hidden',
                  fontWeight: 'bold',
                  transition: '0.5s ease, color 0.5s ease',
                }}>
                {t('login.sendButton')}
              </button>
              <button onClick={closeModal}
                onMouseEnter={() => {
                  if (!isMobile) setIsHovered(true);
                }}
                onMouseLeave={() => {
                  if (!isMobile) setIsHovered(false);
                }}
                style={{
                  color: isHovered ? '#FF33CC' : '#00FFFF',
                  transform: isHovered ? 'scale(1.5)' : 'scale(1)',
                  background: 'none',
                  border: 'none',

                  width: isMobile ? '44px' : 'auto',
                  height: isMobile ? '44px' : 'auto',

                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',

                  padding: 0,
                  fontSize: isMobile ? '1rem' : '1.5rem',

                  cursor: 'pointer',
                  zIndex: 9999,
                }}
              >
                <FontAwesomeIcon icon={faTimesCircle} />
              </button>
              {message && <div style={{ color: '#00FFFF', fontWeight: 'bold', zIndex: '10000' }}>{message}</div>}

            </div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Connexion;
